import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    cachedViews: [], // 用于存储需要缓存的路由组件的名称
    tagsList: [], //缓存的路由组件路由
    activationPath: '', //需要激活的侧边栏
    richTextDialog: {
      status: false,
      title: ''
    }, //富文本弹窗显示
    richTextContent: '' //富文本弹窗显示内容
  },
  mutations: {
    // 定义缓存的路由组件方法
    SetActivationPath(state, obj) {
      state.activationPath = obj;
    },

    SetTagsList(state, { tag, index, direction }) {
      //单个删除 从标签列表中移除该标签
      // state.tagsList.splice(index, 1);
      // state.cachedViews.splice(index, 1);
      // console.log('缓存的路由组件', state.cachedViews, index);
      // 左侧删除 (删除当前索引左侧的所有标签，不包括当前索引)
      if (direction === 'left') {
        state.tagsList.splice(0, index);
        state.cachedViews.splice(0, index);
        // 右侧删除 (删除当前索引右侧的所有标签，不包括当前索引)
      } else if (direction === 'right') {
        state.tagsList.splice(index + 1);
        state.cachedViews.splice(index + 1);
      } else if (direction === 'single') {
        state.tagsList.splice(index, 1);
        state.cachedViews.splice(index, 1);
      } else if (direction === 'others') {
        // state.tagsList.splice(index, 1);
        // state.cachedViews.splice(index, 1);
        // 通过 filter 保留当前标签，删除其他标签
        state.tagsList = state.tagsList.filter(i => i.path === tag.path);
        state.cachedViews = state.cachedViews.filter(view => view === tag.path);
        console.log(1111111, state.tagsList, state.cachedViews);
      }
    },
    SetActivationName(state, name) {
      state.activationName = name;
    },
    //添加组件和组件缓存
    SetCachedViews(state, e) {
      const { name, params, action } = e;
      if (name) {
        state.activationName = name;
      }
      const TagsListName = state.cachedViews.some(tag => tag === action);
      if (!TagsListName) {
        state.cachedViews.push(action);
      }
      const existsInTagsList = state.tagsList.some(tag => tag.path === action);
      state.activationPath = action;
      let tagName = params ? state.activationName + ':' + params : state.activationName;
      if (!existsInTagsList) {
        state.tagsList.push({ name: tagName, path: action }); //将目标路由的名称和路径加入到标签列表（tagsList）中
      }
    },
    //更改CachedViews  重新加入组件到缓存中
    updateCachedViews(state, path) {
      state.cachedViews = state.cachedViews.filter(view => view !== path);
      setTimeout(() => {
        state.cachedViews = [...state.cachedViews, path];
      }, 0);
    },
    //修改富文本弹窗显示 状态
    SetRichTextDialog(state, obj) {
      const { status, title } = obj;
      state.richTextDialog.status = status;
      state.richTextDialog.title = title;
      console.log('1', state, status);
    },
    //修改富文本内容格式
    SetRichTextContent(state, text) {
      state.richTextContent = text;
      console.log('2', state, text);
    }
  },
  actions: {}
});
